export default __webpack_public_path__ + "static/media/ac.c6c88cf4.png";